__turbopack_context__.v({
  "box": "WidgetBox-module-scss-module__26sXHq__box",
  "fade-in": "WidgetBox-module-scss-module__26sXHq__fade-in",
  "no-transform": "WidgetBox-module-scss-module__26sXHq__no-transform",
  "rotate": "WidgetBox-module-scss-module__26sXHq__rotate",
});
